export default __webpack_public_path__ + "static/media/close.312538b5.svg";